import { useTranslation } from 'react-i18next';
import { CircularProgress, Stack, Typography } from '@mui/material';
import ListItem from './ListItem';
import { CategoryFiltersInterface } from '../CategoryFiltersUtils';

interface CategoryFiltersListProps extends CategoryFiltersInterface {
  hideIndex?: boolean;
  headingText?: string;
}

export default function CategoryFiltersList({
  activeCategory,
  hideIndex = false,
  categories = [],
  loading = false,
  headingText,
  onSelectCategory = () => {},
}: Readonly<CategoryFiltersListProps>) {
  const { t } = useTranslation();

  return (
    <Stack direction='column'>
      <Typography
        component='h2'
        variant='subtitle2'
        sx={{
          color: 'text.primary',
          paddingY: 1,
        }}
      >
        {headingText ?? t('categoryList.title')}
      </Typography>
      <Stack
        component='ul'
        sx={{
          padding: 0,
          margin: 0,
          listStyleType: 'none',
        }}
      >
        {!hideIndex && (
          <ListItem
            active={activeCategory === undefined}
            onClickCallback={() => onSelectCategory()}
          >
            {t('categoryList.allCategories')}
          </ListItem>
        )}
        {categories.map((category) => {
          return (
            <ListItem
              key={'regulation-category-link-' + category}
              active={activeCategory === category}
              onClickCallback={() => onSelectCategory(category)}
            >
              {category}
            </ListItem>
          );
        })}
        {loading && <CircularProgress />}
      </Stack>
    </Stack>
  );
}
